export const MARKETING_PAGE_LOAD = 'MARKETING_PAGE_LOAD'; // eslint-disable-line
